<template>
  <div class="bd-y-black p-y-3">
    <div class="container h6 c-gray60">
      <p>To manage your service request or to change your account information,
      go to your Pro Referral account dashboard.
      </p>
      <router-link
          :to="{ name: 'consumer::dashboard' }"
          tag="button"
          class="btn btn-large text-bold m-y-1 w-100:mo"
          selenium="dashboard-button">
        My Dashboard
      </router-link>
      <p>Questions about your request? Call <span class="c-black">1-855-723-2266</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'manage-request',
};
</script>
